import React, { useState } from "react";
import { dataSlider } from "../../data/Slider/dataSlider";
import SlidersModal from "./SlidersModal";
import "./Slider.css";
import { FaHandPointUp } from "react-icons/fa"; 

const Slider = () => {
  const activeIndex =
    dataSlider.findIndex((item) => item.itemActive === "active") || 0;
  const [showModal, setShowModal] = useState(false);
  const [currentImage, setCurrentImage] = useState(null);
  const [isDownloading, setIsDownloading] = useState(false);

  const handleImageClick = (item) => {
    if (item.modalimage || item.modaltext || item.modalzip) {
      setCurrentImage(item);
      setShowModal(true);
      document.body.style.overflow = "hidden";
    } else if (item.url) {
      window.open(item.url, "_blank");
    }
  };

  const closeModal = () => {
    setShowModal(false);
    setCurrentImage(null);
    document.body.style.overflow = "auto";
    setIsDownloading(false);
  };

  const downloadZipFile = () => {
    if (!currentImage?.zipFile) return;

    setIsDownloading(true);
    const zipUrl = `https://itetlax.org.mx/assets/img/ZIP/${currentImage.zipFile}`;

    setTimeout(() => {
      window.open(zipUrl, "_blank");
      setIsDownloading(false);
    }, 1500);
  };

  return (
    <div className="slider-container">
      <div id="imageSlider" className="carousel slide" data-bs-ride="carousel">
        <div className="carousel-inner">
          {dataSlider.map((item, index) => (
            <div
              key={item.id}
              className={`carousel-item ${
                index === activeIndex ? "active" : ""
              }`}
            >
              <div
                className="image-container"
                onClick={() => handleImageClick(item)}
                style={{
                  cursor:
                    item.url ||
                    item.modalimage ||
                    item.modaltext ||
                    item.modalzip
                      ? "pointer"
                      : "default",
                }}
              >
                <img
                  src={`https://itetlax.org.mx/assets/img/imgC_I/${item.imgUrl}`}
                  className="d-block slider-image"
                  alt={item.alt}
                />
                {/* Botón con efecto pulse */}
                {item.buttonActive && (
                  <button className="pulse-button">
                    <FaHandPointUp size={24} />
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
        <div className="mobile-nav-arrows">
          <div
            className="mobile-nav-arrow"
            onClick={() =>
              document.querySelector(".carousel-control-prev").click()
            }
          >
            &lt;
          </div>
          <div
            className="mobile-nav-arrow"
            onClick={() =>
              document.querySelector(".carousel-control-next").click()
            }
          >
            &gt;
          </div>
        </div>
        {/* Controles */}
        <button
          className="carousel-control-prev"
          type="button"
          data-bs-target="#imageSlider"
          data-bs-slide="prev"
        >
          <span
            className="carousel-control-prev-icon"
            aria-hidden="true"
          ></span>
          <span className="visually-hidden">Previous</span>
        </button>
        <button
          className="carousel-control-next"
          type="button"
          data-bs-target="#imageSlider"
          data-bs-slide="next"
        >
          <span
            className="carousel-control-next-icon"
            aria-hidden="true"
          ></span>
          <span className="visually-hidden">Next</span>
        </button>
      </div>

      <SlidersModal
        showModal={showModal}
        currentImage={currentImage}
        isDownloading={isDownloading}
        closeModal={closeModal}
        downloadZipFile={downloadZipFile}
      />
    </div>
  );
};

export default Slider;
